// @flow

import categoriesData from '../categorySummaryMockData.json';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../../apiTypes';
import type { categoryType } from '../../../types';

export const categoriesMock = {
  getSingle: (id: number): Promise<wrappedApiResponseType<categoryType>> => {
    console.log('categoriesMock.getSingle', id);
    const category = categoriesData.find(cat => cat.id === id);

    if (category) {
      return Promise.resolve({
        status: 200,
        statusText: 'OK',
        body: category,
      });
    } else {
      return Promise.reject({
        status: 404,
        statusText: 'Not Found',
      });
    }
  },

  getMany: (): djangoModelApiResponse<categoryType> => {
    console.log('categoriesMock.getMany');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {
        count: categoriesData.length,
        next: null,
        previous: null,
        results: categoriesData,
      },
    });
  },

  getPreferences: (): djangoModelApiResponse<categoryType> => {
    console.log('categoriesMock.getPreferences');
    const preferences = categoriesData.preferences;

    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {
        count: preferences.length,
        next: null,
        previous: null,
        results: preferences,
      },
    });
  },
};
